import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    img: "https://images.pexels.com/photos/4491461/pexels-photo-4491461.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "A creator setting up her storefront from a template.",
    title: "Pick your template",
    body: "Medspa, agency or coach. Four ready-to-sell products load instantly.",
  },
  {
    n: "02",
    img: "https://images.pexels.com/photos/6953867/pexels-photo-6953867.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "A creator recording content while the Studio Advisor drafts her products.",
    title: "Describe what you sell",
    body: "One sentence. The Studio Advisor drafts the title, price, copy and outline.",
  },
  {
    n: "03",
    img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=80",
    alt: "A customer paying through a storefront checkout.",
    title: "Share one link. Get paid.",
    body: "Post it once. Checkout, delivery and analytics run themselves.",
  },
];

export const MzWorkflow = () => (
  <section className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mb-12 sm:mb-16"
      >
        <p className="mz-eyebrow mb-3">Hands-free by design</p>
        <h2 className="mz-h text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
          Three steps. <span className="mz-gold-text">Then it runs itself.</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
        {STEPS.map((s, i) => (
          <motion.article
            key={s.n}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="mz-card overflow-hidden group"
            data-testid={`workflow-step-${i + 1}`}
          >
            <div className="relative h-52 overflow-hidden">
              <img
                src={s.img}
                alt={s.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-[10.5px] font-bold tracking-[0.18em] text-[#AA771C]" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                {s.n}
              </span>
            </div>
            <div className="p-6">
              <h3 className="mz-h text-lg font-semibold">{s.title}</h3>
              <p className="mt-1.5 text-sm text-neutral-500 leading-relaxed">{s.body}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
